export default __webpack_public_path__ + "static/3-74dfe1391d9125c6be7f06a721fc6872.jpeg";